import React from 'react';
import ReactTooltip from 'react-tooltip'

import Form from '../../../components/common/Form';
import {Intent, PopoverInteractionKind, Position, Popover} from '@blueprintjs/core/lib/esm/index';

import axios from "axios";
import {getCurrentUserId, getJwt} from "../../../services/authService";
import {persistent_menu, persistent_menu_start_it, persistent_menu_telegraf} from "../../constants/constants";

import http from "../../../services/httpService";
import toastr from 'toastr';
import {NavLink} from 'react-router-dom';
import $ from 'jquery';
import Joyride, {STATUS} from "react-joyride";
// import ReactGA from "react-ga";

const facebook_app_graph_url = process.env.REACT_APP_FB_URL;
const facebook_app_marketing_url = process.env.REACT_APP_FB_MARKETING_URL;

class WebPushChannel extends Form {
    constructor(props) {
        super(props);
        this.state = {
            clicked_fb: false,
            clicked_wp: false,
            clicked_viber: false,
            fb_spinner: false,
            spinnerActive: false,
            clickedFbPageConnect: '',
            user: {
                facebook_pages_shared: props.facebook_pages_shared || [],
                facebook_pages:
                    {
                        data: props.facebook_pages || []
                    },
                missing_allowed_pages: []
            },
            copiedToClipboard: false,
            selectedInstruction: 'wordpress',
            selectedSkin: 1,
            secondsDelay: 3,
            expirationDays: 7,
            dontShowDays: 0,

            platformsEnabled: this.props.platforms_enabled,
            //tour settings
            steps: [
                {
                    content: 'Follow our simple instructions for WordPress websites and set-up in less than 5 minutes. 🙌',
                    placement: 'top',
                    spotlightPadding: 0,
                    disableBeacon: true,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.webpush-tour-step-1',
                    title: '',
                },
                {
                    content: 'Or generate custom code for Non-WordPress websites. 😎',
                    placement: 'top',
                    spotlightPadding: 0,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.webpush-tour-step-2',
                    title: '',
                }
            ],
            tourRun: false
        };

        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };


    }

    copyToClipboard = (e) => {
        e.preventDefault();
        this.textArea.select();
        document.execCommand('copy');
        e.target.focus();
        this.setState({
            copySuccess: 'You successfully copied webpush Id!',
            copySuccess2: ''
        });
    };

    copyToClipboard2 = (e) => {
        e.preventDefault();
        this.textArea2.select();
        document.execCommand('copy');
        e.target.focus();
        this.setState({
            copySuccess: '',
            copySuccess2: 'You successfully copied html code!'
        });
    };

    selectSkin = (e) => {
        this.setState({selectedSkin: e.target.id});
        if (document.querySelector('.selected')) {
            document.querySelector('.selected').classList.remove('selected');
        }
        e.target.classList.add('selected');

    };

    addSeconds = (e) => {
        //console.log(e.target.value);
        this.setState({secondsDelay: e.target.value});

    };

    addDays = (e) => {
        this.setState({expirationDays: e.target.value})
    };
    addDontShow = (e) => {
        this.setState({dontShowDays: e.target.value})
    };

    addChatbotButton = () => {

        let chatbotState = !this.state.emittoChatbot;
        this.setState({emittoChatbot: chatbotState})

    };
    setChatbotLink = (e) => {
        // console.log('chatbot link set: ', e.target.value);
        this.setState({chatbotLink: e.target.value})

    };
    showScript = () => {
        this.setState({showScript: true})

    };


    handleDisconnectShow = (e) => {
        //console.log("handleDisconnectShow PlatformsSupported, e.target.slot",e.target.slot);
        //console.log("handleDisconnectShow PlatformsSupported,this  ", $(this));
        //console.log("handleDisconnectShow PlatformsSupported,this  ", $(this));
        if (e.target.slot) {
            const targetFade = '#' + e.target.slot;
            //console.log("handleDisconnectShow PlatformsSupported,targetFade",targetFade);
            $(targetFade).fadeToggle();
        }
        //$(this).toggleClass('opened');
        //$('.platform-edit .platform-dropdown').fadeToggle();
        //$('#'+e.target).fadeToggle();
    };

    //handleInfoCircle = () => {
    //    $('#forbidden > .team-user-panel').fadeToggle()
    //};

    handleInfoCircle = (e) => {
        //console.log("handleDisconnectShow PlatformsSupported, e.target.slot", e.target.slot);
        if (e.target.slot) {
            const targetFade = '.forbidden > #' + e.target.slot;
            //console.log("handleDisconnectShow PlatformsSupported,targetFade",targetFade);
            $(targetFade).fadeToggle();
        }
        //$('#forbidden > .team-user-panel').fadeToggle()
        //$('#forbidden > .team-user-panel').fadeToggle()
    };

    handleClosePanel = () => {
        $('#forbidden > .team-user-panel').fadeToggle()
    };

    selectInstruction = (instruction) => {
        // console.log('selected modal: ', instruction)

        this.setState({
            selectedInstruction: instruction,

        })

    };

    toggleWP = async (e) => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Dist platform - Enabled Webpush',
        //     userId: getCurrentUserId(),
        //     label: '',
        //     nonInteraction: true
        // });
        // console.log("PlatformsSupported toggleWP this.state.clicked_wp",this.state.clicked_wp);
        this.setState({clicked_wp: !this.state.clicked_wp, fb_spinner: true});
        await this.props.enablePlatform(e);

        if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled && this.props.platforms_enabled.length > 0) {
            let result = await http.patch('api/feed/' + this.props.sourceId, {active: 1}, {headers: {authorization: getJwt()}});

            this.props.updateSources(result.data);
            this.props.selectSource({id: result.data.id, source_active: true, selected_source_rss: result.data.rss})
        } else if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled.length < 1) {
            let result = await http.patch('api/feed/' + this.props.sourceId, {active: 0}, {headers: {authorization: getJwt()}});

            this.props.updateSources(result.data);
            this.props.selectSource({id: result.data.id, source_active: false})
        }
        this.setState({fb_spinner: false})
    };

    toggleFB = async (e) => {
        //console.log("PlatformsSupported toggleFB this.state.clicked_fb",this.state.clicked_fb);
        await this.setState({clicked_fb: !this.state.clicked_fb});
        await this.props.enablePlatform(e);
        //this.props.appPropagateUserPlatforms(this.state.clicked_fb);
        if (typeof (this.props.appPropagateUserPlatforms) !== 'undefined') {
            this.props.appPropagateUserPlatforms(this.state.clicked_fb);
        }
        if (this.props.feedActiveUpdateOnChange && this.props.platforms_enabled.length < 1) {
            let result = await http.patch('api/feed/' + this.props.sourceId, {active: 0}, {headers: {authorization: getJwt()}});

            this.props.updateSources(result.data);
            this.props.selectSource({id: result.data.id, source_active: false})
        }

    };

    toggleConnect = async (e) => {

        this.setState({
            clickedFbPageConnect: e.target.id,
            spinnerActive: true
        })
        const FB_URL = facebook_app_graph_url;
        let pg_id = e.target.id;
        let pg_token = e.target.attributes.value.nodeValue;
        let feed_id = e.target.attributes.name.nodeValue;
        let page_connected = e.target.title;


        let source_rss = this.props.source_rss;

        //console.log("toggleConnect  appPropagateUserData={this.props.appPropagateUserData}", this.props.appPropagateUserData);

        var url_facebook_graph = FB_URL + pg_id + '/subscribed_apps?access_token=' + pg_token.toString() + '&subscribed_fields=messages,message_deliveries,messaging_optins,messaging_postbacks';
        var url_facebook_get_started = FB_URL + 'me/thread_settings?access_token=' + pg_token;
        var url_facebook_menu = FB_URL + 'me/messenger_profile?access_token=' + pg_token;

        var headers_get_started = {ContentType: "application/json"};

        let paramsToSend = {}

        try {
            if (page_connected !== "Connected") {
                try {
                    const result = await axios.post(url_facebook_graph, {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'undefined'
                        }
                    });

                    // console.log("toggleConnect url_facebook_graph result", result);
                    if (!result) {
                        toastr.error("Facebook api connecting app problem. :(  Please log in again.");
                        this.setState({spinnerActive: false})
                    } else {
                        page_connected = "Connected";
                        if (this.props.onlypage) {
                            //console.log(feed_id);
                            //console.log("this.props.name", this.props.name);

                            //console.log("this.props.onlypage", this.props.onlypage);
                            if (feed_id === "page_source") {
                                paramsToSend = {
                                    page_connected: page_connected,
                                    feed_id: feed_id,
                                    name: this.props.name,
                                    team_name: this.props.team_name,
                                    onlypage: this.props.onlypage
                                };
                                this.setState({spinnerActive: false})
                            } else {
                                paramsToSend = {
                                    page_connected: page_connected,
                                    feed_id: feed_id
                                };
                                this.setState({spinnerActive: false})
                            }

                        } else {
                            paramsToSend = {
                                page_connected: page_connected,
                                feed_id: feed_id
                            };
                        }
                        //console.log("paramsToSend ", paramsToSend);


                        var url_api = '/api/user/' + getCurrentUserId() + '/page/' + pg_id;
                        var headers_def = {authorization: getJwt()};

                        var params_start = {
                            "setting_type": "call_to_actions",
                            "thread_state": "new_thread",
                            "call_to_actions": [
                                {
                                    "payload": "Start"
                                }
                            ]
                        };

                        try {
                            const res = await http.patch(url_api, paramsToSend, {headers: headers_def});
                            const data = await res.data.data;
                            await this.props.enablePlatform({
                                target: {
                                    id: "fb_enable",
                                    title: this.props.sourceId.toString()
                                }
                            });
                            this.props.activateFeed({target: {id: this.props.sourceId.toString(), name: 'activate'}});
                            // console.log("toggleConnect url_api", data);
                            if (!data) {
                                toastr.error("res id does not match. :(  Please log in again.");
                                this.props.history.push('/logout');
                            } else {
                                //let user = data;
                                this.setState({user: data});
                                this.props.appPropagateUserData(data);
                                //console.log("toggleConnecttoggleConnecttoggleConnecttoggleConnect data", data);
                                const id = data.sources.data[0].id;
                                localStorage.setItem("source_clicked", JSON.stringify(id.toString()));
                                // localStorage.setItem("feed_id", JSON.stringify(id.toString()));

                                // try {
                                //     const res_get_started = await axios.post(url_facebook_get_started, params_start, {headers: headers_get_started});
                                //     //console.log("toggleConnect res_get_started", res_get_started);
                                //     if (res_get_started) {
                                //
                                //     }
                                // } catch (ex) {
                                //     //console.log("ex.response", ex.response);
                                //     if (ex.response && ex.response.status === 404)
                                //         toastr.error("Something went wrong... Please refresh and try again.");
                                //
                                //     if (ex.response && ex.response.status === 403) {
                                //         toastr.error(ex.response.data.message);
                                //         //if(missing_permissions.length===0)
                                //         //{
                                //         //    alert("Please, go to https://www.facebook.com/settings?tab=business_tools&section=active    and " +
                                //         //        "recheck allowed permissions for this page. " +
                                //         //        "Both manage_pages and pages_messaging permissions have to be granted for this page. " +
                                //         //        "After this LOGIN via FACEBOOK into Emitto, for changes to take effect.");
                                //         //}
                                //     }
                                //     if (ex.response && ex.response.status === 401) {
                                //         //let errors = { ...this.state.errors }
                                //         //console.log(ex.response.data);
                                //         toastr.error(ex.response.data.message);
                                //         //window.location = "/";
                                //         this.props.history.push('/logout');
                                //     }
                                // }

                                let params_persistent_menu = persistent_menu;
                                if (source_rss.includes('telegraf')) {
                                    params_persistent_menu = persistent_menu_telegraf;
                                } else if (source_rss.includes('startit') || source_rss.includes('nolimithub')) {
                                    params_persistent_menu = persistent_menu_start_it;
                                }
                                // try {
                                //     const res_facebook_menu = await axios.post(url_facebook_menu, params_persistent_menu, {headers: headers_get_started});
                                //     //console.log("toggleConnect res_facebook_menu", res_facebook_menu);
                                //     if (res_facebook_menu) {
                                //
                                //     }
                                // } catch (ex) {
                                //     //console.log("ex.response", ex.response);
                                //     if (ex.response && ex.response.status === 404)
                                //         toastr.error("Something went wrong... Please refresh and try again.");
                                //     if (ex.response && ex.response.status === 403)
                                //         toastr.error(ex.response.data.message);
                                //     if (ex.response && ex.response.status === 401) {
                                //         //let errors = { ...this.state.errors }
                                //         //console.log(ex.response.data);
                                //         toastr.error(ex.response.data.message);
                                //         //window.location = "/";
                                //         this.props.history.push('/logout');
                                //     }
                                // }
                            }
                        } catch (ex) {
                            //console.log("ex.response", ex.response);
                            if (ex.response && ex.response.status === 404)
                                toastr.error("Something went wrong... Please refresh and try again.");
                            if (ex.response && ex.response.status === 401) {
                                //let errors = { ...this.state.errors }
                                //console.log(ex.response.data);
                                toastr.error(ex.response.data.message);
                                //window.location = "/";
                                this.props.history.push('/logout');
                            }
                        }
                    }
                } catch (ex) {
                    //alert("aaaaaaaa");
                    if (ex.response && ex.response.status === 404)
                        toastr.error("Something went wrong... Please refresh and try again.");
                    if (ex.response && ex.response.status === 401) {
                        //let errors = { ...this.state.errors }
                        //console.log(ex.response.data);
                        toastr.error(ex.response.data.message);
                        //window.location = "/";
                        this.props.history.push('/logout');
                    }
                }


            } else {

                try {
                    const result = axios.delete(url_facebook_graph);
                    //console.log("toggleConnect delete(url_facebook_graph result", result);

                    if (!result) {
                        toastr.error("Facebook api disconnecting app problem.. :(  Please log in again.");
                    } else {
                        page_connected = "Not Connected";
                        if (this.props.onlypage) {
                            //console.log(feed_id);
                            //console.log("this.props.name", this.props.name);
                            //console.log("this.props.onlypage", this.props.onlypage);
                            paramsToSend = {
                                page_connected: page_connected,
                                feed_id: feed_id,
                                name: this.props.name,
                                team_name: this.props.team_name,
                                onlypage: this.props.onlypage
                            };
                            //console.log("paramsToSend ", paramsToSend);
                        } else {
                            paramsToSend = {
                                page_connected: page_connected,
                                feed_id: feed_id
                            };
                        }

                        url_api = '/api/user/' + getCurrentUserId() + '/page/' + pg_id;
                        headers_def = {authorization: getJwt()};
                        try {
                            const res = await http.patch(url_api, paramsToSend, {headers: headers_def});
                            const data = res.data.data;
                            //console.log("toggleConnect delete-patch(url_api data", data);
                            if (!data) {
                                toastr.error("res removing id does not match. :(  Please log in again.");
                                this.props.history.push('/logout');
                            } else {
                                //let user = data;
                                this.setState({user: data});
                                //let rmv_persistent_menu = {
                                //    "fields":[
                                //        "persistent_menu"
                                //    ]
                                //};

                                // try {
                                //     const data_rmv_persistent_menu = await axios.delete(url_facebook_menu, {
                                //         params: {
                                //             "fields": [
                                //                 "persistent_menu"
                                //             ]
                                //         }
                                //     }, {headers: headers_get_started});
                                //     //console.log("toggleConnect delete(url_facebook_menu data_rmv_persistent_menu", data_rmv_persistent_menu);
                                //     if (data_rmv_persistent_menu) {
                                //
                                //     }
                                // } catch (ex) {
                                //     //console.log("ex.response", ex.response);
                                //     if (ex.response && ex.response.status === 404)
                                //         toastr.error("Something went wrong... Please refresh and try again.");
                                //     if (ex.response && ex.response.status === 403)
                                //         toastr.error("DELETING persistent_menu ERROR - " + ex.response.data.error.message);
                                //     if (ex.response && ex.response.status === 401) {
                                //         //let errors = { ...this.state.errors }
                                //         //console.log(ex.response.data);
                                //         toastr.error(ex.response.data.message);
                                //         //window.location = "/";
                                //         this.props.history.push('/logout');
                                //     }
                                // }
                            }
                        } catch (ex) {
                            //console.log("ex.response", ex.response);
                            if (ex.response && ex.response.status === 404)
                                toastr.error("Something went wrong... Please refresh and try again.");
                            if (ex.response && ex.response.status === 403)
                                toastr.error(ex.response.data.error.message);
                            if (ex.response && ex.response.status === 401) {
                                //let errors = { ...this.state.errors }
                                //console.log(ex.response.data);
                                toastr.error(ex.response.data.message);
                                //window.location = "/";
                                this.props.history.push('/logout');
                            }
                        }
                    }

                } catch (ex) {
                    //console.log("ex.response", ex.response);
                    if (ex.response && ex.response.status === 404)
                        toastr.error("Something went wrong... Please refresh and try again.");
                    if (ex.response && ex.response.status === 403)
                        toastr.error("DELETING ERROR - " + ex.response.data.error.message);
                    if (ex.response && ex.response.status === 401) {
                        //let errors = { ...this.state.errors }
                        //console.log(ex.response.data);
                        toastr.error(ex.response.data.message);
                        //window.location = "/";
                        this.props.history.push('/logout');
                    }
                }

            }
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                //let errors = { ...this.state.errors }
                //console.log(ex.response.data);
                toastr.error(ex.response.data.message);
                //window.location = "/";
                this.props.history.push('/logout');
            }
        }

    };

    componentDidUpdate = async () => {


        if (this.state.spinnerActive) {
            this.setState({spinnerActive: false});
        }


    }

    componentDidMount = () => {
        //console.log("componentDidMount PlatformsSupported, this.props",this.props);

        let {user: userData, sourceId, facebook_pages, platforms_enabled, facebook_pages_shared} = this.props;
        let user = {
            ...userData,
            facebook_pages: {
                data: facebook_pages
            },
            facebook_pages_shared,
            missing_allowed_pages: []
        };
        this.setState({user: user});
        let facebook_platform_enabled = platforms_enabled && platforms_enabled.indexOf("fb") > -1;
        let count_pages = facebook_pages ? facebook_pages.length : "";
        let page_source_connected = (count_pages && sourceId) ? facebook_pages.filter(el => {
            return (el.feed_id && el.feed_id.toString() === sourceId.toString())
        }) : "";
        // console.log("Platfom Supported- will mount - platforms_enabled ", platforms_enabled);
        if (page_source_connected.length || facebook_platform_enabled) {
            this.setState({clicked_fb: true});

        } else {
            this.setState({clicked_fb: false});
        }
        // this.checkAdsManagementPermission(user.user_fb_id, user.user_fb_extended_token);
    }
    runGuidedTour = () => {
        this.setState({
            tourRun: true
        })
    }
    handleJoyrideCallback = (data) => {
        //console.log('joyride callback data: ', data)

        const {status} = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            this.setState({tourRun: false});
        }
        if (data.index === 0) {
            this.setState({
                selectedInstruction: 'wordpress'
            })
        } else {
            this.setState({
                selectedInstruction: 'not-wordpress'
            })
        }

    }
    getHelpers = (StoreHelpers) => {
        this.helpers = StoreHelpers;
    };
    copyToClipboardTextarea = () => {
        //console.log('code-parameters value: ', document.get('code-parameters').value);
        const text = document.getElementsByClassName('code-parameters')[0].innerText;
        const elem = document.createElement("textarea")
        document.body.appendChild(elem);
        elem.value = text;
        elem.select();
        document.execCommand("copy");
        document.body.removeChild(elem);
        toastr.success('Link copied to clipboard.')
    }


    render() {
        let {
            sourceId,
            openModal,
            onlypage,
            source_rss,
            platforms_enabled,
            web_push_id,
            fromDistributionPlatforms
        } = this.props;
        let {tourRun, steps} = this.state
        let show_disconnect = true;
        if (typeof (openModal) === 'undefined') {
            show_disconnect = false;
        }
        const {
            clicked_fb,
            clicked_wp,
            clicked_viber
        } = this.state;
        let webpush_platform_enabled = platforms_enabled && platforms_enabled.indexOf("wp") > -1;

        let facebook_pages = this.state.user.facebook_pages.data;
        let facebook_pages_shared = this.state.user.facebook_pages_shared;

        let count_pages = 0;
        let count_pages_shared = 0;
        const facebook_app_id = process.env.REACT_APP_FACEBOOK_APP_ID;

        if (typeof (facebook_pages) !== 'undefined') {
            count_pages = facebook_pages.length;
        }
        if (typeof (facebook_pages_shared) !== 'undefined') {
            count_pages_shared = facebook_pages_shared.length;
        }
        return (
            <React.Fragment>
                <div className="display-flex flex-end take-panel-width">
                    <span id='webpush-start-tour' onClick={this.runGuidedTour} className='start-guided-tour'>Start guided
                        tour</span>
                </div>
                <Joyride
                    callback={this.handleJoyrideCallback}
                    continuous={true}
                    getHelpers={this.getHelpers}
                    run={tourRun}
                    scrollToFirstStep={true}
                    showProgress={true}
                    showSkipButton={true}
                    steps={steps}
                    styles={{
                        options: {
                            zIndex: 10000,
                            primaryColor: '#26AAE1'
                        },
                    }}
                />
                {webpush_platform_enabled || clicked_wp
                    ?
                    <React.Fragment>

                        <div className='channel-heading-container'>
                            <h3 className='all-caps'>WebPush</h3>
                            <div>
                                <span style={{fontSize: 11}} className='enabled-label'>Enabled</span>
                                <Popover
                                    interactionKind={PopoverInteractionKind.CLICK}

                                    position={Position.LEFT_TOP}
                                    minimal={true}
                                >
                                    <span className="fas fa-ellipsis-v" style={{
                                        color: 'black',
                                        marginLeft: 10,
                                        cursor: 'pointer'
                                    }}></span>
                                    <div className="three-dots-popover padding-10">
                                        <a id="team_delete_btn" onClick={this.toggleWP}
                                           id="wp_disable" title={sourceId}
                                           href="#">Disable {this.state.fb_spinner ?
                                            <i className='fa fa-spin fa-spinner'></i> : ''}</a>
                                    </div>
                                </Popover>
                            </div>
                        </div>

                        <div className='full-width'>
                            <div className="display-flex align-items-center take-panel-width">
                                <p className='full-width m-lg-t'>This is your webpush ID</p>

                            </div>
                            <form className='webpush-id-container'>
                                        <textarea
                                            ref={(textarea) => this.textArea = textarea}
                                            value={this.props.web_push_id}
                                        />
                                <button className='btn-action' onClick={(e) => this.copyToClipboard(e)}>Copy</button>
                            </form>
                        </div>
                        <div id='webpush-instructions-container' className="flex-row space-between">
                            <div
                                className={this.state.selectedInstruction === "wordpress" ? "single-option-container active webpush-tour-step-1" : "single-option-container webpush-tour-step-1"}
                                onClick={() => this.selectInstruction('wordpress')}>

                                <img className="" src="/img/wordpress-logo.png"
                                     alt="wordpress-logo"/>

                                <div className="text-container">
                                    <h3>WordPress websites</h3>
                                    <p>Install plugin without code by uploading .zip directly to
                                        WordPress or find Emitto in
                                        Plugins.</p>
                                    {/*<button className='btn-action'>Select*/}
                                    {/*</button>*/}
                                </div>
                            </div>

                            <div className={
                                this.state.selectedInstruction === "not-wordpress" ? "single-option-container active webpush-tour-step-2" : "single-option-container webpush-tour-step-2"}
                                 onClick={() => this.selectInstruction('not-wordpress')}
                            >

                                <img className="" src="/img/rss-feed-symbol.png" alt="rss-logo"/>

                                <div className="text-container">
                                    <h3>Not WordPress websites</h3>
                                    <p>We’ll walk you through the installment process step by
                                        step.</p>
                                    {/*<button className='btn-action'>Select</button>*/}
                                </div>
                            </div>
                        </div>
                        <div className="webpush-instructions-container">
                            {this.state.selectedInstruction === 'wordpress'
                                ?
                                <div className="onboardingChoose pop-up skin-panel padding-top-30">


                                    <p>
                                        For WordPress websites, we’ve developed a quick and easy to
                                        install <strong>Wordpress
                                        Plugin</strong>.<br/><br/>

                                        <strong>Emitto WordPress plugin</strong> lets you customize and
                                        setup
                                        the activation pop-up on your
                                        website in just a couple of minutes, without the need to write a
                                        single
                                        line of code.<br/><br/>

                                        After activation, you’ll be able to take full advantage of
                                        Web/Browser
                                        push as a distribution
                                        channel.<br/>
                                        You will have an active pop-up that will help you acquire
                                        subscribers
                                        and re-engage them with new
                                        content through Emitto.
                                    </p>
                                    <h2><strong>Installation</strong></h2>


                                    <div className='list-item-container'>
                                        <h3>1) Install Emitto plugin on your WordPress website</h3>
                                        <p>In your WordPress dashboard -> go to plugins section -> then
                                            choose
                                            “<strong>Add
                                                New</strong>”.<br/>
                                            <strong>Search for “Emitto” in the Wordpress plugin
                                                directory.</strong> Emitto plugin should
                                            show up.<br/>
                                            Click “<strong>Install Now</strong>” to download and install the
                                            plugin. Then click
                                            “<strong>Activate</strong>” to activate it.<br/></p>
                                        <img className="web-push-modal-full-image"
                                             src="/img/webpush_wordpress_1.png"/>
                                    </div>


                                    <div className='list-item-container'>
                                        <h3>2) Plugin settings</h3>
                                        <p><img src="/img/not-wordpress.png"/> Emitto menu item will in your
                                            WordPress admin menu.
                                            Click on it to open Emitto plugin settings page. You can change
                                            all
                                            the plugin settings
                                            here.<br/><br/></p>
                                        <p>This is your unique Emitto Web/Browser push ID.</p>
                                        <form className='webpush-id-container'>
                                                 <textarea ref={(textarea) => this.textArea = textarea}
                                                           value={this.props.web_push_id}
                                                 />
                                            <button className='btn-action'
                                                    onClick={(e) => this.copyToClipboard(e)}>Copy
                                            </button>
                                        </form>
                                        {this.state.copySuccess ?
                                            <p className="success-text copy-success">{this.state.copySuccess}</p> : ''}
                                        <p><strong>Copy and paste it into the plugin.</strong> This is a
                                            necessary step for plugin to work.
                                        </p>
                                        <img className="web-push-modal-full-image"
                                             src="/img/webpush_wordpress_2.png"/>
                                        <p>Save changes. After this, your pop-up is activated and it will be
                                            shown to your website visitors.
                                            🙌</p>
                                    </div>


                                    <div className='list-item-container margin-bottom-10'>
                                        <h3>3) See it in action</h3>
                                        <p>Visit your website to see how it will look like when someone
                                            lands on
                                            your website.<br/>
                                            Make sure you become your first subscriber and test it out.
                                            Enjoy!
                                        </p>
                                    </div>
                                    <div data-intercom-target="Login button"></div>
                                </div>
                                :
                                <div className="onboarding-panel padding-top-30">
                                    {/*<h2>Customization</h2>*/}
                                    <div className='list-item-container popup-pics'>
                                        <h3>1) Choose pop-up skin.</h3>
                                        <p>Choose one of the four pop-up skins which goes with your website
                                            flow!</p>
                                        <div className="row popup-pics">
                                            <div className="col-md-6">
                                                <img id='1'
                                                     className={this.state.selectedSkin === 1 ? 'selected' : ''}
                                                     onClick={(e) => this.selectSkin(e)} src="/img/popups/1.png"
                                                     alt="1"/>
                                            </div>
                                            <div className="col-md-6">
                                                <img id='2'
                                                     className={this.state.selectedSkin === 2 ? 'selected' : ''}
                                                     onClick={(e) => this.selectSkin(e)} src="/img/popups/2.png"
                                                     alt="2"/>
                                            </div>
                                            <div className="col-md-6">
                                                <img id='3'
                                                     className={this.state.selectedSkin === 3 ? 'selected' : ''}
                                                     onClick={(e) => this.selectSkin(e)} src="/img/popups/3.png"
                                                     alt="3"/>
                                            </div>
                                            <div className="col-md-6">
                                                <img id='4'
                                                     className={this.state.selectedSkin === 4 ? 'selected' : ''}
                                                     onClick={(e) => this.selectSkin(e)} src="/img/popups/4.png"
                                                     alt="4"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='list-item-container add-seconds'>
                                        <h3>2) Choose pop-up appearing delay</h3>
                                        <p>Set how much <span className='text-bold'>seconds</span> from website load
                                            would you like for pop-up to
                                            appear.</p>
                                        <input maxLength="3" value={this.state.secondsDelay} type="text"
                                               pattern="[0-9]*"

                                               onChange={(e) => this.addSeconds(e)}/>
                                    </div>
                                    <div className='list-item-container expiration-days'>
                                        <h3>3) Set expiration days</h3>
                                        <p>Set number of <span className='text-bold'>days</span> which indicates how
                                            long the pop-up will stay
                                            hidden to a user who closed
                                            it.</p>
                                        <input maxLength="3" value={this.state.expirationDays} type="text"
                                               pattern="[0-9]*"
                                               onChange={(e) => this.addDays(e)}/>

                                    </div>

                                    {this.state.selectedSkin === '3' ?
                                        <div>
                                            {/*{console.log('selected skin: ', this.state.selectedSkin)}*/}
                                            <div className='list-item-container dont-show-days'>
                                                <h3><span className='step-number'>4</span> Set "don't show" days
                                                </h3>
                                                <p>Set number of days which indicates how long the pop-up will
                                                    stay hidden to a user who
                                                    clicked "Don't show this again"</p>
                                                <input maxLength="3" value={this.state.dontShowDays} type="text"
                                                       pattern="[0-9]*"
                                                       onChange={(e) => this.addDontShow(e)}/>
                                            </div>

                                        </div>
                                        :
                                        ''

                                    }


                                    <button onClick={this.showScript}
                                            className="btn-action btn-lg m-lg-t m-lg-b">Generate Script
                                    </button>
                                    {this.state.showScript ?
                                        <div className='webpush-script-container'>
                                            <p className='m-m-b'><a
                                                href="https://emitto.io/popup-assets/popup.zip"><span
                                                className='text-bold'>Click here</span></a> to
                                                download .zip file which contains <span
                                                    className='text-bold'>popup.js</span> and <span
                                                    className='text-bold'>service-worker.js</span>.
                                                They should be included in your workspace files and placed in
                                                the same folder.</p>
                                            <p className='m-m-b'>On the start of the <span>popup.js</span> file,
                                                change first parameters
                                                with your own: </p>
                                            <p className='code-parameters'>
                                                const popupSkin = {this.state.selectedSkin}; <br/>
                                                <br/>
                                                //number of seconds after which the pop-up should appear<br/>
                                                const secondsDelay = {this.state.secondsDelay};<br/>
                                                <br/>
                                                //number of days which indicates how long the pop-up will stay
                                                hidden to a user who closed
                                                it<br/>
                                                const expirationDays = {this.state.expirationDays};<br/>
                                                <br/>
                                                //how many days the pop-up will stay hidden to a user who
                                                clicked 'don't show'<br/>
                                                const dontShowDays = {this.state.dontShowDays};<br/>
                                                <br/>
                                                //your unique Emitto ID (don't change this)
                                                <br/>
                                                const emittoCustomId
                                                = {"'" + this.props.web_push_id + "'"};<br/>
                                                <br/>
                                                {/*//using emitto chatbot button (only for pop-up skin 4)<br/>*/}
                                                {/*const chatbot = {this.state.emittoChatbot};<br/>*/}
                                                {/*<br/>*/}
                                                {/*//link to your page facebook messenger<br/>*/}
                                                {/*const emittoChatbotLink = {this.state.chatbotLink}<br/>*/}

                                            </p>

                                            <button id='copy-clipboard-textarea'
                                                    onClick={this.copyToClipboardTextarea}>
                                                Copy to Clipboard
                                            </button>
                                            <p className='m-m-t m-m-b'>
                                                Insert script file into your workspace and link it just
                                                above <span
                                                className='text-bold'>&lt;/body&gt;</span> tag like this:
                                            </p>
                                            <p className='code-parameters'>
                                                &lt;script src= '<span
                                                className='text-yellow text-bold'>*PATH_TO_SCRIPT</span>/popups.js' &gt; &lt;/script&gt;
                                            </p>

                                            <p className='m-m-t'>*Change <span
                                                className=' text-bold'>PATH_TO_SCRIPT</span> to your custom
                                                folder
                                                where the <span className='text-bold'>popups.js</span> is
                                                located (for ex. '/scripts/')
                                            </p>
                                            <h2 className='text-center text-bold text-light-blue m-lg-t'>And
                                                that's it, you're ready to
                                                go!</h2>

                                        </div>
                                        :
                                        ''
                                    }
                                    <div data-intercom-target="Login button"></div>
                                </div>

                            }
                        </div>
                    </React.Fragment>
                    :
                    <div className="col-xs-6 align-right">

                        <div id="wp_enable" onClick={this.toggleWP}
                             style={{cursor: "pointer", color: "rgb(38, 170, 225)"}}>
                            <p id="wp_enable" title={sourceId}>


                                <span title={sourceId} target="_blank" id="wp_enable"
                                      onClick={this.toggleWP}>
                                    <button title={sourceId} id="wp_enable"
                                            className="btn-action dist-platf-button">Enable
                                    </button>
                                </span>
                                {/*<a href="#" title={sourceId} id="wp_enable" onClick={this.toggleWP} >*/}
                                {/*<button className="btn-action dist-platf-button">Enable</button>*/}
                                {/*</a>*/}
                            </p>
                        </div>

                    </div>
                }


                {/*{webpush_platform_enabled || clicked_wp*/}
                {/*    ?*/}
                {/*    <div className="section-content"*/}
                {/*         style={{*/}
                {/*             marginTop: "35px",*/}
                {/*             marginBottom: "0",*/}
                {/*             maxWidth: fromDistributionPlatforms ? 416 : 1024*/}
                {/*         }}>*/}


                {/*    </div>*/}

                {/*    :*/}
                {/*    ""*/}
                {/*}*/}


            </React.Fragment>

        )
    }

}

export default WebPushChannel;